
import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

interface CalculatorItem {
  name: string;
  path: string;
  available: boolean;
}

interface CalculatorCategoryProps {
  title: string;
  viewAllLink: string;
  items: CalculatorItem[];
}

const CalculatorCategorySection = ({ title, viewAllLink, items }: CalculatorCategoryProps) => {
  const filteredItems = items.filter(item => item.available);
  
  return (
    <div className="mb-10">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-xl font-semibold">{title}</h3>
        <Link to={viewAllLink} className="font-bold text-primary flex items-center gap-1 hover:underline">
          View all <ChevronRight size={16} />
        </Link>
      </div>
      <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        {filteredItems.map((item, idx) => (
          <li key={idx}>
            <Link to={item.path} className="font-bold text-blue-600 hover:underline block py-1">
              {item.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CalculatorCategorySection;
